import React, { useState } from "react";
import { ThumbUpOutlined, ThumbDownOutlined, ThumbUp, ThumbDown } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import axiosInstance from "../utils/axios";
import { useAuth } from '../context/AuthContextProvider';

const LikeResponse = ({message}) => {
  const [selected, setSelected] = useState(null); // "like" or "dislike"
  const { userId } = useAuth();

  const handleSelection = async (choice) => {
    const newSelected = choice === selected ? null : choice;
    setSelected(newSelected);

    if (newSelected !== null) {
      try {
        await axiosInstance.post("/submit_feedback", {
          thumbs: newSelected === "like",
          accuracy: 0,
          completeness: 0,
          explainability: 0,
          humanlike: 0,
          nonbias: 0,
          comments: "",
          question_id: message.question_id || '',
          user_id: userId || '',
          question: message.question || '',
          session_id: message.session_id || '',
          response: message.response?.strDescription
          ? message.response?.strDescription
          : JSON.stringify(
              message?.response?.description?.map((item) => ({
                title: item.title,
                text: item.text,
              }))
            ) || "",
          //response: ""
        });
      } catch (error) {
        console.error("Error submitting feedback:", error);
      }
    }
  };

  return (
    <div className="flex items-center">
      <div className="text-[10px]"><i>Like the response?</i></div>
      <div className="flex items-center ml-1">
        <IconButton
          onClick={() => handleSelection("like")}
          style={{ fontSize: "14px", color: selected === "like" ? "#00555C" : "#00555C", padding: '4px' }}
        >
          {selected === "like" ? <ThumbUp fontSize="inherit" /> : <ThumbUpOutlined fontSize="inherit" />}
        </IconButton>
        <IconButton
          onClick={() => handleSelection("dislike")}
          style={{ fontSize: "14px", color: selected === "dislike" ? "#00555C" : "#00555C", padding: '4px'}}
        >
          {selected === "dislike" ? <ThumbDown fontSize="inherit" /> : <ThumbDownOutlined fontSize="inherit" />}
        </IconButton>
      </div>
    </div>
  );
};

export default LikeResponse;
